<template>
    <div class="enps-problem-categories">
        <div class="enps-problem-categories__title">Проблемные категории</div>
        <div class="enps-problem-categories__hint">Доля низких оценок (1–2) от всех оценок категории</div>

        <div v-if="categories.length === 0" class="enps-problem-categories__empty">Низких оценок за период нет</div>

        <div
            v-for="category in categories"
            :key="category.categoryId"
            class="enps-problem-categories__row"
            :class="{ 'enps-problem-categories__row_low-sample': category.isLowSample }"
        >
            <span class="enps-problem-categories__name">{{ category.categoryTitle }}</span>
            <span class="enps-problem-categories__bar">
                <span class="enps-problem-categories__bar-fill" :style="{ width: category.lowShare + '%' }"></span>
            </span>
            <span class="enps-problem-categories__share">
                {{ category.lowShare }}% ({{ category.lowCount }} из {{ category.ratingsCount }})
            </span>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

// Топ категорий по ДОЛЕ низких оценок (бэкенд считает и сортирует — getProblemCategories()):
// средняя оценка спокойно прячет хвост, 4.2 при 15% единиц выглядит благополучно. Категории с
// выборкой ниже порога приглушены — доля от двух оценок не факт, а случайность.
@Component
class EnpsProblemCategories extends Vue {
    @Prop({ type: Array, default: () => [] })
    categories;
}

export default EnpsProblemCategories;
</script>
<style lang="scss">
.enps-problem-categories {
    flex: 1;
    padding: 15px;
    border-radius: 8px;
    background-color: var(--color-white);
    box-shadow: 0px 1px 10px rgba(88, 88, 88, 0.15);

    &__title {
        font-weight: 600;
    }

    &__hint {
        margin-bottom: 12px;
        color: #a0a0a0;
        font-size: 0.8125rem;
    }

    &__empty {
        padding: 20px 0;
        color: #a0a0a0;
        text-align: center;
    }

    &__row {
        display: flex;
        align-items: center;
        gap: 10px;
        padding: 6px 0;

        &_low-sample {
            opacity: 0.55;
        }
    }

    &__name {
        flex: 1;
        min-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    &__bar {
        position: relative;
        width: 120px;
        height: 8px;
        border-radius: 4px;
        background-color: #f1f4f6;
        flex-shrink: 0;
    }

    &__bar-fill {
        position: absolute;
        left: 0;
        top: 0;
        height: 100%;
        border-radius: 4px;
        background-color: #f44336;
    }

    &__share {
        width: 130px;
        flex-shrink: 0;
        text-align: right;
        color: #767676;
        font-size: 0.8125rem;
    }
}
</style>
